class ProductForm extends HTMLElement {
  constructor() {
    super();   
    // console.log(">>>>", this);
    this.act = this.querySelector('[act-cart-btn]');
     // console.log(">>>>", this.act);
    if(this.act){
    this.act.addEventListener('click', this.onClickHandler.bind(this));
    }else{
    this.form = this.querySelector('form');
    if(this.form){  
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    }
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
         submitButton.innerHTML = 'Add To Cart';
      });
  }
   onClickHandler(evt) {
     // alert();
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    this.variantId =  this.act.getAttribute('data-variant-id');
    const submitButton = this.act;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    submitButton.innerHTML = 'Adding To Cart';
    let data = {
      'id': this.variantId,
      'quantity': 1
    };
     console.log(">>>data",data);
    const body = JSON.stringify({
      id: this.variantId,
      quantity: 1,
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
         if($('body').hasClass('template-account')){
           submitButton.innerHTML = 'Buy Again';
         }
           else{
        submitButton.innerHTML = 'Add To Cart';
         }
      });
     setTimeout(function(){
     if($('body').hasClass('template-cart')){
       window.location.href='/cart';
     }
       },1000);
  }
}

customElements.define('product-form', ProductForm);
